import { Suspense } from 'react';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { MARKET_PROMOTION_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { DonationBatchMembersPage } from '@/features/marketPromotion/pages/DonationBatchMembersPage';
import { donationBatchMembersSearchSchema } from '@/features/marketPromotion/types/marketPromotionP2.types';
import { parsePositiveIdParams } from '@/utils/routeParams';

export const Route = createFileRoute('/_auth/market-promotion/publish-panel/batches/$batchId')({
  beforeLoad: () => requirePermission(MARKET_PROMOTION_PERMISSIONS.PUBLISH_PANEL_VIEW),
  parseParams: (rawParams) => {
    const params = parsePositiveIdParams(rawParams);
    if (params === null) throw notFound();
    return params;
  },
  validateSearch: donationBatchMembersSearchSchema,
  component: function DonationBatchMembersRoute() {
    const { batchId } = Route.useParams();
    const search = Route.useSearch();
    return (
      <ErrorBoundary moduleName="Donation Batch Members">
        <Suspense fallback={<PageLoader />}>
          <DonationBatchMembersPage batchId={batchId} search={search} />
        </Suspense>
      </ErrorBoundary>
    );
  },
});
